import { Redirect, Route, Switch } from 'wouter';
import { ConversationsPage, SettingsPage, UsersPage } from './admin/OtherPages';
import { LeadsPage } from './admin/LeadsPage';
import { homeFor, useAuth } from './auth/AuthContext';
import { ChangePasswordPage, LoginPage, RequireRole } from './auth/pages';
import { ChatPage } from './chat/ChatPage';
import { Shell } from './components/Shell';

const NAV = [
  { href: '/admin', label: 'Leads' },
  { href: '/admin/conversas', label: 'Conversas' },
  { href: '/admin/usuarios', label: 'Usuários', adminOnly: true },
  { href: '/admin/configuracoes', label: 'Configurações', adminOnly: true },
];

function Home() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Redirect to={user ? homeFor(user) : '/entrar'} />;
}

export function App() {
  return (
    <Switch>
      <Route path="/orcamento" component={ChatPage} />
      <Route path="/entrar" component={LoginPage} />
      <Route path="/trocar-senha" component={ChangePasswordPage} />
      <Route path="/admin/*?">
        <RequireRole roles={['admin', 'comercial']}>
          <Shell nav={NAV}>
            <Switch>
              <Route path="/admin" component={LeadsPage} />
              <Route path="/admin/conversas" component={ConversationsPage} />
              <Route path="/admin/usuarios">
                <RequireRole roles={['admin']}>
                  <UsersPage />
                </RequireRole>
              </Route>
              <Route path="/admin/configuracoes">
                <RequireRole roles={['admin']}>
                  <SettingsPage />
                </RequireRole>
              </Route>
              <Route>
                <Redirect to="/admin" />
              </Route>
            </Switch>
          </Shell>
        </RequireRole>
      </Route>
      <Route component={Home} />
    </Switch>
  );
}
